// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onfido-details-wrapper {
  position: relative;
  margin-bottom: 1.5rem;
}
.onfido-details-wrapper:empty {
  margin-bottom: 0;
}

.ban-button {
  background-color: var(--red6) !important;
  font-weight: 600 !important;
  color: white !important;
}
.ban-button:hover {
  background-color: rgba(204, 0, 66, 0.8117647059) !important;
}

.react-tel-input.is-invalid {
  border: 1px solid var(--red6) !important;
  border-radius: 0.25rem;
}
.react-tel-input input.form-control {
  background: var(--white);
  border: 1px solid var(--black1);
  border-radius: 0.5rem;
  width: 100%;
  min-height: 40px;
  padding-left: 4rem;
  outline: none;
  box-shadow: none;
  color: var(--black9);
}
.react-tel-input input.form-control::placeholder {
  color: var(--black6);
}
.react-tel-input input.form-control:active {
  border-color: var(--purple6);
}
.react-tel-input input.form-control:active + .flag-dropdown {
  border-color: var(--purple6);
}
.react-tel-input input.form-control:hover {
  border-color: var(--purple6);
}
.react-tel-input input.form-control:hover + .flag-dropdown {
  border-color: var(--purple6);
}
.react-tel-input input.form-control:focus {
  outline: none;
  box-shadow: none;
}
.react-tel-input .flag-dropdown {
  transition: border 0.3s ease;
  background: var(--white);
  border: 1px solid var(--black1);
  border-radius: 0.5rem 0 0 0.5rem;
}
.react-tel-input .flag-dropdown .selected-flag {
  background: var(--white) !important;
  width: 3.25rem !important;
  border-radius: 0.5rem 0 0 0.5rem;
}
.react-tel-input .flag-dropdown .selected-flag .arrow {
  left: 30px;
}
.react-tel-input .flag-dropdown .selected-flag:hover {
  background: var(--white) !important;
}
.react-tel-input .flag-dropdown .selected-flag:focus {
  background: var(--white) !important;
}
.react-tel-input .flag-dropdown.open {
  background: var(--white);
  border-radius: 0.5rem 0 0 0;
}
.react-tel-input .flag-dropdown.open .selected-flag {
  border-radius: 0.5rem 0 0 0;
  background: var(--white) !important;
  width: 3.25rem !important;
}
.react-tel-input .flag-dropdown.open .selected-flag:hover {
  background: var(--white) !important;
}
.react-tel-input .flag-dropdown.open .selected-flag:focus {
  background: var(--white) !important;
}
.react-tel-input .flag-dropdown.open .country-list {
  box-shadow: none;
  margin-top: -5px;
  background: var(--white);
  color: var(--black9);
  border: 1px solid var(--purple6);
  border-top: 0;
}
.react-tel-input .flag-dropdown.open .country-list .country {
  padding: 0.5rem 1rem;
}
.react-tel-input .flag-dropdown.open .country-list .country.highlight {
  background: var(--black1);
}
.react-tel-input .flag-dropdown.open .country-list .country:hover {
  background: var(--black1);
}

.onfido-details-wrapper {
  position: relative;
  margin-bottom: 1.5rem;
}
.onfido-details-wrapper:empty {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/settings/user/personal/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAIA;EACE,wCAAA;EACA,2BAAA;EACA,uBAAA;AADF;AAGE;EACE,2DAAA;AADJ;;AAOE;EACE,wCAAA;EACA,sBAAA;AAJJ;AAOE;EACE,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AALJ;AAOI;EACE,oBAAA;AALN;AAQI;EACE,4BAAA;AANN;AAQM;EACE,4BAAA;AANR;AAUI;EACE,4BAAA;AARN;AAUM;EACE,4BAAA;AARR;AAYI;EAEE,aAAA;EACA,gBAAA;AAXN;AAmBE;EACE,4BAAA;EACA,wBAAA;EACA,+BAAA;EACA,gCAAA;AAjBJ;AAoBI;EACE,mCAAA;EACA,yBAAA;EACA,gCAAA;AAlBN;AAoBQ;EACE,UAAA;AAlBV;AAqBM;EACE,mCAAA;AAnBR;AAqBM;EACE,mCAAA;AAnBR;AAuBI;EACE,wBAAA;EACA,2BAAA;AArBN;AAuBM;EACE,2BAAA;EACA,mCAAA;EACA,yBAAA;AArBR;AAuBQ;EACE,mCAAA;AArBV;AAuBQ;EACE,mCAAA;AArBV;AAyBM;EACE,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gCAAA;EACA,aAAA;AAvBR;AAyBQ;EACE,oBAAA;AAvBV;AAyBU;EACE,yBAAA;AAvBZ;AA0BU;EACE,yBAAA;AAxBZ;;AAkCA;EACE,kBAAA;EACA,qBAAA;AA/BF;AAiCE;EACE,gBAAA;AA/BJ","sourcesContent":[".onfido-details-wrapper {\n  position: relative;\n  margin-bottom: 1.5rem;\n\n  &:empty {\n    margin-bottom: 0;\n  }\n}\n\n\n.ban-button {\n  background-color: var(--red6) !important;\n  font-weight: 600 !important;\n  color: white !important;\n\n  &:hover {\n    background-color: darken(#ff0052cf, 10%) !important;\n  }\n}\n\n.react-tel-input {\n\n  &.is-invalid {\n    border: 1px solid var(--red6) !important;\n    border-radius: .25rem;\n  }\n\n  input.form-control {\n    background: var(--white);\n    border: 1px solid var(--black1);\n    border-radius: .5rem;\n    width: 100%;\n    min-height: 40px;\n    padding-left: 4rem;\n    outline: none;\n    box-shadow: none;\n    color: var(--black9);\n\n    &::placeholder {\n      color: var(--black6);\n    }\n\n    &:active {\n      border-color: var(--purple6);\n\n      & + .flag-dropdown {\n        border-color: var(--purple6);\n      }\n    }\n\n    &:hover {\n      border-color: var(--purple6);\n\n      & + .flag-dropdown {\n        border-color: var(--purple6);\n      }\n    }\n\n    &:focus {\n      //border-color: var(--purple6);\n      outline: none;\n      box-shadow: none;\n\n      & + .flag-dropdown {\n        //border-color: var(--purple6);\n      }\n    }\n  }\n\n  .flag-dropdown {\n    transition: border 0.3s ease;\n    background: var(--white);\n    border: 1px solid var(--black1);\n    border-radius: .5rem 0 0 .5rem;\n\n\n    .selected-flag {\n      background: var(--white) !important;\n      width: 3.25rem !important;\n      border-radius: .5rem 0 0 .5rem;\n\n        .arrow {\n          left: 30px;\n        }\n\n      &:hover {\n        background: var(--white) !important;\n      }\n      &:focus  {\n        background: var(--white) !important;\n      }\n    }\n\n    &.open {\n      background: var(--white);\n      border-radius: .5rem 0 0 0;\n\n      .selected-flag {\n        border-radius: .5rem 0 0 0;\n        background: var(--white) !important;\n        width: 3.25rem !important;\n\n        &:hover {\n          background: var(--white) !important;\n        }\n        &:focus  {\n          background: var(--white) !important;\n        }\n      }\n\n      .country-list {\n        box-shadow: none;\n        margin-top: -5px;\n        background: var(--white);\n        color: var(--black9);\n        border: 1px solid var(--purple6);\n        border-top: 0;\n\n        .country {\n          padding: 0.5rem 1rem;\n\n          &.highlight {\n            background: var(--black1);\n          }\n\n          &:hover {\n            background: var(--black1);\n          }\n        }\n\n      }\n    }\n  }\n}\n\n\n.onfido-details-wrapper {\n  position: relative;\n  margin-bottom: 1.5rem;\n\n  &:empty {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
